// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Invite-header{padding:16px 0 0 16px}", "",{"version":3,"sources":["webpack://./src/views/user-roles/components/invite-modal/invite-modal.scss"],"names":[],"mappings":"AAAA,eACC,qBAAA","sourcesContent":[".Invite-header {\n\tpadding: 16px 0 0 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
